import React, { useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { Button, Stack, Grid } from '@mui/material';
import FilterBadge from './filter/FilterBadge';
import FilterContext from '../contexts/FilterContext';

export class FilterDefinition {
  constructor(component, key, label, optionData, filterBuilder, render = (val) => val) {
    this.component = component;
    this.key = key;
    this.label = label;
    this.optionData = optionData;
    this.filterBuilder = filterBuilder;
    this.render = render;
  }

  renderSelector(setFilter) {
    return React.createElement(
      this.component,
      {
        key: this.key,
        filterKey: this.key,
        label: this.label,
        options: this.optionData,
        onApplyFilter: (v) => this.onApplyFilter(v, setFilter),
      },
      {}
    );
  }

  onApplyFilter(v, setFilter) {
    setFilter(this.filterBuilder(v));
  }
}

const StagingFilterBuilder = ({ filterDefs }) => {
  const { filters, resetFilter, resetFilters, setFilter } = useContext(FilterContext);

  const handleFiltersClear = () => {
    resetFilters();
  };

  const handleFilterClear = (filter) => {
    resetFilter(filter);
  };

  const filterBadges = useMemo(() => filters.filter((f) => f.showFilterBadge), [filters]);

  if (!filterDefs || filterDefs.length <= 0) return <div />;

  return (
    <Grid container>
      <Grid
        sx={{
          margin: '20px',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          flexGrow: '99',
          padding: '10px 20px',
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
          {filterDefs.map((def) => def.renderSelector(setFilter))}
        </Stack>
      </Grid>
      {filterBadges && filterBadges.length > 0 ? (
        <Grid
          sx={{
            margin: '20px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            flexGrow: '99',
            padding: '10px 20px',
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
            {filterBadges.map((filter) => (
              <FilterBadge
                key={filter.key()}
                filterDef={filterDefs.find((def) => def.key === filter.key())}
                value={filter.stringify()}
                onClick={() => handleFilterClear(filter)}
              />
            ))}
            <Button style={{ minWidth: 100 }} onClick={handleFiltersClear}>
              <u>CLEAR ALL</u>
            </Button>
          </Stack>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default connect()(StagingFilterBuilder);
